export default __webpack_public_path__ + "static/photoelectric8-ac7cf42bb084cfbfd41c5347e68a0379.png";